import classnames from 'classnames';
import { get } from 'lodash';

import { useShowSuccessSection } from './hooks';
import { FailedSection, SuccessSection } from './components';

import useStyles from './styles';

import type { BaseProps } from '../../../../interfaces';

export function TotalDetailSection({ classes = {} }: BaseProps) {
  const componentClasses = useStyles();
  const showSuccessSection = useShowSuccessSection();
  return (
    <div
      className={classnames(
        get(componentClasses, 'root', null),
        get(classes, 'root', null),
      )}
    >
      {showSuccessSection ? <SuccessSection /> : <FailedSection />}
    </div>
  );
}
